import React from "react";

import { Blank, Icon } from "grommet-icons";

export const TelegramIcon: Icon = (props) => (
  <Blank {...props} viewBox="0 0 48 48">
    <path
      fill="#000"
      fillRule="evenodd"
      d="M24 0C10.748 0 0 10.744 0 24c0 13.254 10.748 24 24 24 13.254 0 24-10.746 24-24C48 10.744 37.254 0 24 0Zm6.448 35.742c.376.266.86.332 1.292.17a1.356 1.356 0 0 0 .844-.982c1.014-4.764 3.474-16.824 4.396-21.156a.914.914 0 0 0-.745-1.093.94.94 0 0 0-.487.043c-4.892 1.812-19.958 7.464-26.116 9.742A.967.967 0 0 0 9 23.4a.966.966 0 0 0 .692.89 487.52 487.52 0 0 1 6.386 1.976s1.694 5.116 2.576 7.716a1.024 1.024 0 0 0 .704.672 1.01 1.01 0 0 0 .948-.242l3.61-3.408s4.168 3.054 6.532 4.738ZM17.602 25.618l1.96 6.462.436-4.092L31.88 17.272a.324.324 0 0 0-.167-.562.33.33 0 0 0-.233.048l-13.878 8.86Z"
      clipRule="evenodd"
    />
  </Blank>
);
